import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

//Import Images
//import error from "../assets/images/error-img.png";
import MobiLogo from "../assets/images/brands/MobihunterDark.png";
import maintenance from "../assets/images/coming-soon.svg"
//import Countdown from "react-countdown";

class ComingSoon extends Component {
  constructor() {
    super()
    this.renderer.bind(this)
  }

  renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>You are good to go!</span>
    } else {
      // Render a countdown
      return (
        <>
          <div className="coming-box">
            {days} <span>Days</span>
          </div>{" "}
          <div className="coming-box">
            {hours} <span>Hours</span>
          </div>{" "}
          <div className="coming-box">
            {minutes} <span>Minutes</span>
          </div>{" "}
          <div className="coming-box">
            {seconds} <span>Seconds</span>
          </div>
        </>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        <MetaTags>
          <title>Coming Soon | Mobihunter</title>
        </MetaTags>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-white">
            <i className="fas fa-home h2"/>
          </Link>
        </div>

        <div className="my-5 pt-sm-5">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  <Link to="/">
                    <img src={MobiLogo} alt="mobi-logo" height="58" />
                  </Link>
                  <Row className="justify-content-center mt-5">
                    <Col sm="4">
                      <div className="maintenance-img">
                        <img
                          src={maintenance}
                          alt=""
                          className="img-fluid mx-auto d-block"
                        />
                      </div>
                    </Col>
                  </Row>
                  <h4 className="mt-5">Coming Soon</h4>
                  {/*<p className="text-muted">*/}
                  {/*  Coming Soon*/}
                  {/*</p>*/}

                  {/*<Row className="justify-content-center mt-5">*/}
                  {/*  <Col md="8">*/}
                  {/*    <div className="counter-number">*/}
                  {/*      <Countdown date="2021/12/31" className="counter-number" renderer={this.renderer} />*/}
                  {/*    </div>*/}
                  {/*  </Col>*/}
                  {/*</Row>*/}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default ComingSoon;